import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { BasicScrollView } from "@/components/BasicScrollView";
import { Link, RelativePathString, useRouter } from 'expo-router';
import Head from 'expo-router/head';
import * as AppUtils from '@/utilities/AppUtils';
import { CustomText, CustomTextStyles } from '@/components/CustomText';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import Footer from '@/components/Footer';
import { AppText } from '@/components/AppText';
import { Pressable, StyleSheet, TextInput as RNTextInput, View } from 'react-native';
import { Button as Button95, Hourglass, Panel, TextInput } from 'react95-native-rabbl';
import { ExternalLink } from '@/components/ExternalLink';
import { Image } from 'expo-image';
import * as AppConsts from '@/utilities/AppConsts';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    alignItems: 'center',
    backgroundColor: 'transparent',
    gap: 20,
  },
  formElement: {
    maxWidth: 300,
  },
  contentWrapper: {
    padding: 20,
    gap: 20,
  },
  inputWrapper: {
    flexDirection: 'row',
  },
  appStoreImage: {
    width: 200,
    height: 59,
  },
  appStoreImage2: {
    width: 300,
    height: 102,
  },
});

const TEST_FLIGHT_LINK = "https://apps.apple.com/us/app/testflight/id899247664";

export default function JoinAppleConfirm() {
  return (
    <BasicScrollView center={true}>
      <Meta title={"Join on Apple devices"} />
      <Panel variant='raised' elevation={4}>
        <View style={AppConstants.STYLES.padding20gap20center}>
          <AppText>Thanks. Once we add you to the beta test program, you'll get an invite by email.</AppText>
          <AppText>You can prepare by installing the <Link href={TEST_FLIGHT_LINK} style={CustomTextStyles.link} target='_blank'>Apple TestFlight App</Link>.</AppText>
          <ExternalLink href={TEST_FLIGHT_LINK} target='_blank' asChild={AppUtilities.isWeb()}>
            <Image source={require('@/assets/images/testflight300x102.png')} style={styles.appStoreImage2} />
          </ExternalLink>
        </View>
      </Panel>
      <Footer />
    </BasicScrollView>
  );
}
